import { Award, Star, BookOpen, Shield, Users, Scale } from "lucide-react";
import { PageHero, Breadcrumbs, TestimonialBand, FadeIn } from "@/components/Shared";

const ACCREDITATIONS = [
  {
    icon: Award,
    title: "The Times Best Law Firms 2026",
    text: "Listed in The Times Best Law Firms 2026 and commended for Crime — one of three major hallmarks of recognition received by the firm.",
  },
  {
    icon: Star,
    title: "Chambers and Partners 2026",
    text: "Ranked as a Leading Firm in Chambers and Partners 2026. Our Managing Director, Namita Pawa, is individually ranked and has moved up to Band 4.",
  },
  {
    icon: BookOpen,
    title: "Legal 500",
    text: "Ranked as a Leading Firm in the Legal 500 for Crime: \u201cThe team at Hallinans has a highly deserved reputation as dedicated to achieving the best result in serious and complex criminal litigation.\u201d",
  },
  {
    icon: Shield,
    title: "Specialist Fraud Panel",
    text: "A member of the Specialist Fraud Panel since its inception — recognising the depth of our experience in serious fraud and financial crime.",
  },
  {
    icon: Users,
    title: "Retained by the Police Federation",
    text: "Retained to advise Police Federation members on disciplinary and regulatory matters, as well as any follow-on criminal proceedings.",
  },
  {
    icon: Scale,
    title: "Legal Aid Agency contract",
    text: "We hold our own client contract with the Legal Aid Agency, reflecting our enduring commitment to publicly funded criminal defence work.",
  },
];

export default function Accreditations() {
  return (
    <main data-testid="accreditations-page">
      <PageHero
        eyebrow="Accreditations & rankings"
        title="Independently recognised, year after year."
        lead="Our devotion to clients and tenacious hard work has gained us recognition from The Times, Chambers and Partners and the Legal 500 — the three leading independent assessments of law firms in England and Wales."
      />
      <Breadcrumbs items={[{ label: "Accreditations & Rankings" }]} />

      <section className="bg-white py-20 sm:py-28 lg:py-32">
        <div className="brand-container">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {ACCREDITATIONS.map((a, i) => (
              <FadeIn key={i} delay={(i % 3) * 0.08} className="h-full">
                <div className="brand-panel-pale flex h-full flex-col border-t-2 border-brand-gold p-8" data-testid={`accreditation-card-${i}`}>
                  <a.icon className="size-7 text-brand-gold" />
                  <h2 className="mt-6 text-lg font-medium text-brand-navy">{a.title}</h2>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{a.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <TestimonialBand />
    </main>
  );
}
